/**
 * 시스템 설정 API
 */
import apiClient from './client';

export interface SystemSettings {
  defaultModel: string;
  defaultLanguage: string;
  defaultTemperature: string;
  topK: number;
  similarityThreshold: number;
}

export const systemSettingsApi = {
  async get(): Promise<SystemSettings> {
    const res = await apiClient.get<{ success: boolean; data: SystemSettings }>('/api/system-settings');
    return res.data.data;
  },
  async save(settings: SystemSettings): Promise<SystemSettings> {
    const res = await apiClient.put<{ success: boolean; data: SystemSettings }>('/api/system-settings', settings);
    return res.data.data;
  },
};
